import { Subscription } from 'rxjs';
import { LinhaService } from './../../providers/linha.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { NewsService } from '../../providers/noticias.service';
import { BASE_URL, URL_BANNERS } from '../../config';
import { Http } from '@angular/http';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, OnDestroy {

  listNews = [];
  linhasList = [];
  sub: Subscription;
  slides = [
    {
      bg: `${URL_BANNERS}banner.png`,
      titulo: 'Há mais de 50 anos <br/> cuidando do seu transporte.'
    }
  ];

  constructor(
    private newsService: NewsService,
    private http: Http,
    private linhas: LinhaService
  ) {}

  ngOnInit() {
    this.loadNews();
    this.loadLinhas();
  }

  loadNews() {

    const page = 1;
    const limit = 3;

    this.sub = this.newsService.getNews(page, limit)
    .subscribe(
      result => {
        this.listNews = result.dados;
      },
      error => {
        console.log('Ops' + error);
      }
    );

  }

  loadLinhas() {
    this.sub = this.linhas.getLinhas()
    .subscribe(data => {
      this.linhasList = data.linhas;
    });
  }


  ngOnDestroy() {
    this.sub.unsubscribe();
  }

}
